<template>
	<div>
		<app-table
			title="Encuestas"
			name="employeesAwards"
			:filter-columns="false"
			:rows="wonPresents"
			:columns="columns"
			:main-list="false"
			class="is-not-selectable"
			@on-search-event="$emit('on-search', $event)">
			<template slot="rows" slot-scope="{ row }">
				<td v-show="showRow(columns, 1)" class="is-not-selectable border-top">{{row.name}}</td>
				<td v-show="showRow(columns, 2)">{{row.points}}</td>
				<td v-show="showRow(columns, 3)">
					<img :src="row.icon.urlImage.web" alt="ícono del premio">
				</td>
			</template>
		</app-table>
	</div>
</template>
<script>
import { mapState } from 'vuex';

function created() {
	this.$store.dispatch('presentsConfiguration/loadWonPresentsByEmployee');
}

function beforeDestroy() {
	this.$store.dispatch('presentsConfiguration/clearPresentsByEmployee');
}

function data() {
	return {
		columns: [
			{
				id: 1,
				name: 'Nombre de Premio',
				value: 'name',
				checked: true,
				visible: true,
			},
			{
				id: 2,
				name: 'Puntos',
				value: 'points',
				checked: true,
				visible: true,
			},
			{
				id: 3,
				name: 'Fecha Canje',
				value: 'date',
				checked: true,
				visible: true,
			},
		],
	};
}

export default {
	name: 'employee-awards-list',
	beforeDestroy,
	computed: {
		...mapState('presentsConfiguration', {
			wonPresents: state => state.presentsByEmployee.gotIt,
		}),
	},
	created,
	data,
};
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/awards/employee-awards-list.vue